import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Loader2 } from "lucide-react";
import { AdminAuthProvider, useAdminAuth } from "./AuthContext";
import { NewCountProvider } from "./NewCountContext";
import AdminLayout from "./AdminLayout";
import Login from "./pages/Login";
import ChangePassword from "./pages/ChangePassword";
import Dashboard from "./pages/Dashboard";
import Inbox from "./pages/Inbox";
import MessageDetail from "./pages/MessageDetail";
import Users from "./pages/Users";
import AuditLog from "./pages/AuditLog";

const FullLoader = () => (
  <div className="min-h-screen bg-[#1A2E24] flex items-center justify-center text-white" data-testid="admin-loading">
    <Loader2 className="h-6 w-6 animate-spin" />
  </div>
);

const Protected = ({ roles, children }) => {
  const { user } = useAdminAuth();
  if (user === null) return <FullLoader />;
  if (user === false) return <Navigate to="/admin/login" replace />;
  if (user.must_change_password) return <Navigate to="/admin/skift-adgangskode" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/admin/dashboard" replace />;
  return <AdminLayout>{children}</AdminLayout>;
};

const AdminRoutes = () => (
  <Routes>
    <Route path="login" element={<Login />} />
    <Route path="skift-adgangskode" element={<ChangePassword />} />
    <Route path="dashboard" element={<Protected><Dashboard /></Protected>} />
    <Route path="indbakke" element={<Protected><Inbox /></Protected>} />
    <Route path="indbakke/:id" element={<Protected><MessageDetail /></Protected>} />
    <Route path="brugere" element={<Protected roles={["admin"]}><Users /></Protected>} />
    <Route path="log" element={<Protected roles={["admin"]}><AuditLog /></Protected>} />
    <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
  </Routes>
);

const AdminApp = () => (
  <AdminAuthProvider>
    <NewCountProvider>
      <Helmet>
        <meta name="robots" content="noindex, nofollow, noarchive" />
        <title>Adminpanel · Lotusgruppen</title>
      </Helmet>
      <AdminRoutes />
    </NewCountProvider>
  </AdminAuthProvider>
);

export default AdminApp;
